// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2716%27 height=%2716%27 viewBox=%270 0 16 16%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M15.6166 9.24763L15.6166 13.1908C15.6036 13.9477 15.2911 14.6686 14.7474 15.1953C14.2037 15.7221 13.4733 16.0117 12.7163 16.0007L2.90022 16.0007C2.14329 16.0117 1.41288 15.7221 0.869187 15.1953C0.325497 14.6686 0.0129153 13.9477 -1.22836e-07 13.1908L-2.98002e-07 9.18349C0.00190862 9.06692 0.0499384 8.95586 0.133569 8.87463C0.217199 8.79341 0.329613 8.74864 0.446187 8.75013C0.562718 8.74878 0.675047 8.7936 0.758646 8.8748C0.842244 8.95599 0.89032 9.06697 0.892374 9.18349L0.892375 13.1908C0.901179 13.7147 1.11759 14.2137 1.49407 14.5782C1.87055 14.9426 2.3763 15.1427 2.90022 15.1345L12.7163 15.1345C13.2403 15.1427 13.746 14.9426 14.1225 14.5782C14.499 14.2137 14.7154 13.7147 14.7242 13.1908L14.7242 9.24763C14.7242 9.12929 14.7712 9.0158 14.8549 8.93212C14.9385 8.84845 15.052 8.80144 15.1704 8.80144C15.2887 8.80144 15.4022 8.84845 15.4859 8.93212C15.5695 9.0158 15.6166 9.12929 15.6166 9.24763ZM11.1547 4.26483C11.1548 4.32433 11.143 4.38326 11.12 4.43814C11.0971 4.49303 11.0633 4.54276 11.0208 4.58441C10.9349 4.66885 10.8192 4.71617 10.6987 4.71617C10.5783 4.71617 10.4626 4.66885 10.3766 4.58441L8.26116 2.48398L8.26116 11.6453C8.26042 11.7651 8.21242 11.8796 8.1276 11.9642C8.04278 12.0487 7.92801 12.0962 7.80828 12.0965C7.74856 12.0977 7.68922 12.0868 7.63379 12.0645C7.57835 12.0423 7.52794 12.0092 7.48555 11.9671C7.44316 11.925 7.40965 11.8748 7.387 11.8196C7.36436 11.7643 7.35304 11.7051 7.35373 11.6453L7.35373 2.48454L5.23935 4.58441C5.15351 4.66882 5.03793 4.71612 4.91754 4.71612C4.79715 4.71612 4.68158 4.66882 4.59573 4.58441C4.55306 4.54284 4.51915 4.49314 4.496 4.43826C4.47284 4.38337 4.46091 4.3244 4.46091 4.26483C4.46091 4.20526 4.47284 4.14629 4.496 4.0914C4.51915 4.03651 4.55306 3.98682 4.59573 3.94525L7.48647 1.07571C7.52838 1.03294 7.57847 0.999051 7.63376 0.976054C7.68905 0.953057 7.7484 0.941424 7.80828 0.941848C7.9285 0.943127 8.04352 0.991133 8.12898 1.07571L11.0208 3.94581C11.0633 3.98739 11.0969 4.03703 11.1199 4.09182C11.1429 4.1466 11.1547 4.20542 11.1547 4.26483Z%27 fill=%27%23003DA5%27 stroke=%27%23003DA5%27 stroke-width=%270.5%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-margin {
  margin-right: 5%;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: "#EDF4FA";
}

.design-intent-header {
  background-color: rgb(237, 244, 250);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 8px 20px 8px 0;
}

.font-color {
  color: #003da5;
}

.task-header-project-name {
  cursor: pointer;
}

.approve-design-intent {
  padding: 10px;
}
.approve-design-intent .file-list-data-row:nth-child(1) {
  width: 350px !important;
}
.approve-design-intent .file-list-data-row:nth-child(2) {
  width: 100px !important;
}
.approve-design-intent .file-list-data-row:nth-child(3) {
  width: 200px !important;
}
.approve-design-intent .file-list-data-row:nth-child(4) {
  width: 200px !important;
}
.approve-design-intent .p-button.p-button-rounded {
  border: hidden !important;
}
.approve-design-intent a {
  cursor: pointer;
}

.viewFileName .p-fileupload .p-fileupload-content {
  background: none;
}

.error-text-di {
  color: red;
  font-weight: 800;
  font-size: 8px;
  position: absolute;
}

.special_char_alert {
  font-size: 0.8rem;
  color: #FF0000;
}

.font-size-10 {
  font-size: 0.8rem !important;
}

.set-autocomplete-height .p-autocomplete {
  line-height: 12px;
  font-size: 10px;
}
.set-autocomplete-height .p-autocomplete-dropdown {
  border: 1px solid #ced4da;
  background: #ffffff;
  color: #ced4da;
}

.col-sm-2 {
  position: relative;
}

.p-fileupload {
  position: relative;
  width: 100%;
  padding-top: 16px;
}
.p-fileupload .p-button,
.p-fileupload .p-button:hover {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
  color: #ffffff;
  /* background: #6366F1; */
  border: 0px;
  padding: 0.85rem 1.25rem;
  background-color: transparent !important;
  background-repeat: no-repeat !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.p-fileupload .p-fileupload-choose-selected .p-button-label {
  color: red;
}
.p-fileupload .p-button[aria-label=Upload],
.p-fileupload .p-button[aria-label=Cancel],
.p-fileupload .p-button-icon {
  display: none;
}
.p-fileupload .p-fileupload-buttonbar {
  background: transparent;
  border: 0;
  padding: 0 20px;
}
.p-fileupload .p-fileupload-content {
  background: #ffffff;
  padding: 10px;
  border: 0;
  color: #495057;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
  position: absolute;
  top: 69%;
  left: 0;
}
.p-fileupload .p-fileupload-content .p-progressbar {
  display: none;
}
.p-fileupload .p-fileupload-row {
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
  height: 30px;
}
.p-fileupload .p-fileupload-row div {
  font-size: 10px;
}
.p-fileupload .p-fileupload-row .p-badge,
.p-fileupload .p-fileupload-row .p-button {
  display: none;
}

.p-checkbox.p-checkbox-disabled,
.disabled-text {
  color: #acacac;
}

.enabled-text {
  color: #595959;
}

.disabled-add {
  opacity: 0.5;
  pointer-events: none;
}

.delete-icons {
  cursor: pointer;
}

sup {
  color: red;
}

.footer-buttons {
  padding: 5;
  background: "#FAFAFA";
}

.align-item-center {
  align-items: center;
  justify-content: center;
  display: flex;
  height: 100%;
}

.upload-cic-pmp-wrapper {
  margin-left: 25px;
  color: #003da5;
  padding-top: 16px;
}

.rejection-reason-header {
  margin-left: 20px;
  padding: 5px;
}

.rejection-table {
  padding: 10px 10px 10px 20px;
}
.rejection-table .p-datatable-selectable .p-selectable-row {
  cursor: default !important;
}
.rejection-table .p-datatable .p-column-header-content {
  justify-content: left;
}

.approval-status-text {
  margin-left: 10px;
  font-size: 14px;
  font-weight: bold;
}
.approval-status-text.Approved {
  color: #03a000;
}
.approval-status-text.Rejected {
  color: #ff0000;
}

._loading_overlay_wrapper > .content-layout {
  padding-top: 8px;
  position: relative;
  overflow: hidden;
  height: 100%;
}
._loading_overlay_wrapper > .content-layout .pi-times {
  position: absolute;
  width: 14px;
  height: 14px;
  right: 41px;
  top: 23px;
  cursor: pointer;
}
._loading_overlay_wrapper > .content-layout .icon-items .filter-icon {
  cursor: pointer;
  color: #003da5;
  width: 14px;
  height: 19px;
  margin-top: 8px;
}
._loading_overlay_wrapper > .content-layout .icon-items .add-new-design-intent-icon {
  cursor: pointer;
  color: #003da5;
  width: 18px;
  height: 18px;
  margin-top: 9px;
}
._loading_overlay_wrapper > .content-layout .icon-items .icon-label {
  font-size: 10px;
  color: #003da5;
  line-height: 13px;
  padding-top: 8px;
}
._loading_overlay_wrapper > .content-layout .icon-items .p-checkbox + .icon-label {
  padding-top: 3px;
}
._loading_overlay_wrapper > .content-layout .icon-items.disabled {
  pointer-events: none;
  opacity: 0.4;
}
._loading_overlay_wrapper > .content-layout.task-layout {
  height: auto;
}
._loading_overlay_wrapper.tab-wrapper {
  border: 0 !important;
  border-radius: 0;
}
._loading_overlay_wrapper.tab-wrapper > .content-layout {
  background: rgba(1, 104, 191, 0.07);
  padding-top: 0;
}
._loading_overlay_wrapper.tab-wrapper > .content-layout .tabular-view {
  position: relative;
  padding-bottom: 38px;
}
._loading_overlay_wrapper.tab-wrapper > .content-layout .tabular-view .form-buttons {
  position: absolute;
  background: white;
  text-align: right;
  width: 100%;
  left: 0;
  bottom: 0;
}

.artworkStatus .cic-img .pi-times {
  right: 0px !important;
  top: 0px !important;
  position: relative !important;
}

.ps-error-msg {
  margin-left: 30px;
}

.footerbutton-display {
  display: flex !important;
  justify-content: space-between !important;
}

.footerbutton-flex {
  display: flex;
  gap: 24px;
}

.vpn-warning {
  font-size: 14px;
  color: #ff0000;
  padding-left: 15px;
}

.mass-update-intent-icon {
  cursor: pointer;
  color: #003da5;
  font-size: 1.5rem;
  margin-top: 9px;
}

.email_share_button {
  padding: 4px 8px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/AWMJobs/DesignJobs/index.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;AACF;;AAEA;EACE,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EAwBE,aAAA;AAtBF;AACI;EACE,uBAAA;AACN;AAEI;EACE,uBAAA;AAAN;AAGI;EACE,uBAAA;AADN;AAII;EACE,uBAAA;AAFN;AAME;EACE,yBAAA;AAJJ;AASE;EACE,eAAA;AAPJ;;AAYE;EACE,gBAAA;AATJ;;AAaA;EACE,UAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAVF;;AAaA;EACE,iBAAA;EACA,cAAA;AAVF;;AAYA;EACE,4BAAA;AATF;;AAaE;EACE,iBAAA;EACA,eAAA;AAVJ;AAaE;EACE,yBAAA;EACA,mBAAA;EACA,cAAA;AAXJ;;AAeA;EACE,kBAAA;AAZF;;AAeA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;AAZF;AAcE;;EAEE,oEAAA;EACA,cAAA;EACA,yBAAA;EACA,WAAA;EACA,wBAAA;EACA,wCAAA;EACA,uCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAZJ;AAgBI;EACE,UAAA;AAdN;AAkBE;;;EAGE,aAAA;AAhBJ;AAmBE;EACE,uBAAA;EACA,SAAA;EACA,eAAA;AAjBJ;AAoBE;EACE,mBAAA;EACA,aAAA;EACA,SAAA;EACA,cAAA;EACA,+BAAA;EACA,8BAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;AAlBJ;AAoBI;EACE,aAAA;AAlBN;AAsBE;EACE,aAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;AApBJ;AAsBI;EACE,eAAA;AApBN;AAuBI;;EAEE,aAAA;AArBN;;AA0BA;;EAEE,cAAA;AAvBF;;AA0BA;EACE,cAAA;AAvBF;;AA0BA;EACE,YAAA;EACA,oBAAA;AAvBF;;AA0BA;EACE,eAAA;AAvBF;;AA0BA;EACE,UAAA;AAvBF;;AA0BA;EACE,UAAA;EACA,qBAAA;AAvBF;;AA0BA;EACE,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;AAvBF;;AA0BA;EACE,iBAAA;EACA,cAAA;EACA,iBAAA;AAvBF;;AA0BA;EACE,iBAAA;EACA,YAAA;AAvBF;;AA0BA;EACE,4BAAA;AAvBF;AAyBE;EACE,0BAAA;AAvBJ;AA0BE;EACE,qBAAA;AAxBJ;;AA6BA;EACE,iBAAA;EACA,eAAA;EACA,iBAAA;AA1BF;AA4BE;EACE,cAAA;AA1BJ;AA6BE;EACE,cAAA;AA3BJ;;AAgCE;EAEE,gBAAA;EAEA,kBAAA;EACA,gBAAA;EACA,YAAA;AA/BJ;AAiCI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;AA/BN;AAmCM;EACE,eAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAjCR;AAoCM;EACE,eAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAlCR;AAqCM;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAnCR;AAsCM;EACE,gBAAA;AApCR;AAuCM;EACE,oBAAA;EACA,YAAA;AArCR;AAyCI;EACE,YAAA;AAvCN;AA2CE;EACE,oBAAA;EACA,gBAAA;AAzCJ;AA2CI;EACE,mCAAA;EACA,cAAA;AAzCN;AA2CM;EACE,kBAAA;EACA,oBAAA;AAzCR;AA2CQ;EACE,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;AAzCV;;AAiDA;EACE,qBAAA;EACA,mBAAA;EACA,6BAAA;AA9CF;;AAiDA;EACE,iBAAA;AA9CF;;AAiDA;EACE,wBAAA;EACA,yCAAA;AA9CF;;AAiDA;EACE,aAAA;EACA,SAAA;AA9CF;;AAgDA;EACE,eAAA;EACC,cAAA;EACA,kBAAA;AA7CH;;AAgDA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;AA7CF;;AAgDA;EACE,2BAAA;AA7CF","sourcesContent":[".header-margin {\n  margin-right: 5%;\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  background-color: \"#EDF4FA\";\n}\n\n.design-intent-header {\n  background-color: rgb(237, 244, 250);\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 20px 8px 0;\n}\n\n.font-color {\n  color: #003da5;\n}\n\n.task-header-project-name {\n  cursor: pointer;\n}\n\n.approve-design-intent {\n  .file-list-data-row {\n\n    &:nth-child(1) {\n      width: 350px !important;\n    }\n\n    &:nth-child(2) {\n      width: 100px !important;\n    }\n\n    &:nth-child(3) {\n      width: 200px !important;\n    }\n\n    &:nth-child(4) {\n      width: 200px !important;\n    }\n  }\n\n  .p-button.p-button-rounded {\n    border: hidden !important;\n  }\n\n  padding: 10px;\n\n  a {\n    cursor: pointer;\n  }\n}\n\n.viewFileName {\n  .p-fileupload .p-fileupload-content {\n    background: none;\n  }\n}\n\n.error-text-di {\n  color: red;\n  font-weight: 800;\n  font-size: 8px;\n  position: absolute;\n}\n\n.special_char_alert{\n  font-size: 0.8rem;\n  color: #FF0000;\n}\n.font-size-10{\n  font-size: 0.8rem !important;\n}\n\n.set-autocomplete-height {\n  .p-autocomplete {\n    line-height: 12px;\n    font-size: 10px;\n  }\n\n  .p-autocomplete-dropdown {\n    border: 1px solid #ced4da;\n    background: #ffffff;\n    color: #ced4da;\n  }\n}\n\n.col-sm-2 {\n  position: relative;\n}\n\n.p-fileupload {\n  position: relative;\n  width: 100%;\n  padding-top: 16px;\n\n  .p-button,\n  .p-button:hover {\n    background-image: url(\"data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M15.6166 9.24763L15.6166 13.1908C15.6036 13.9477 15.2911 14.6686 14.7474 15.1953C14.2037 15.7221 13.4733 16.0117 12.7163 16.0007L2.90022 16.0007C2.14329 16.0117 1.41288 15.7221 0.869187 15.1953C0.325497 14.6686 0.0129153 13.9477 -1.22836e-07 13.1908L-2.98002e-07 9.18349C0.00190862 9.06692 0.0499384 8.95586 0.133569 8.87463C0.217199 8.79341 0.329613 8.74864 0.446187 8.75013C0.562718 8.74878 0.675047 8.7936 0.758646 8.8748C0.842244 8.95599 0.89032 9.06697 0.892374 9.18349L0.892375 13.1908C0.901179 13.7147 1.11759 14.2137 1.49407 14.5782C1.87055 14.9426 2.3763 15.1427 2.90022 15.1345L12.7163 15.1345C13.2403 15.1427 13.746 14.9426 14.1225 14.5782C14.499 14.2137 14.7154 13.7147 14.7242 13.1908L14.7242 9.24763C14.7242 9.12929 14.7712 9.0158 14.8549 8.93212C14.9385 8.84845 15.052 8.80144 15.1704 8.80144C15.2887 8.80144 15.4022 8.84845 15.4859 8.93212C15.5695 9.0158 15.6166 9.12929 15.6166 9.24763ZM11.1547 4.26483C11.1548 4.32433 11.143 4.38326 11.12 4.43814C11.0971 4.49303 11.0633 4.54276 11.0208 4.58441C10.9349 4.66885 10.8192 4.71617 10.6987 4.71617C10.5783 4.71617 10.4626 4.66885 10.3766 4.58441L8.26116 2.48398L8.26116 11.6453C8.26042 11.7651 8.21242 11.8796 8.1276 11.9642C8.04278 12.0487 7.92801 12.0962 7.80828 12.0965C7.74856 12.0977 7.68922 12.0868 7.63379 12.0645C7.57835 12.0423 7.52794 12.0092 7.48555 11.9671C7.44316 11.925 7.40965 11.8748 7.387 11.8196C7.36436 11.7643 7.35304 11.7051 7.35373 11.6453L7.35373 2.48454L5.23935 4.58441C5.15351 4.66882 5.03793 4.71612 4.91754 4.71612C4.79715 4.71612 4.68158 4.66882 4.59573 4.58441C4.55306 4.54284 4.51915 4.49314 4.496 4.43826C4.47284 4.38337 4.46091 4.3244 4.46091 4.26483C4.46091 4.20526 4.47284 4.14629 4.496 4.0914C4.51915 4.03651 4.55306 3.98682 4.59573 3.94525L7.48647 1.07571C7.52838 1.03294 7.57847 0.999051 7.63376 0.976054C7.68905 0.953057 7.7484 0.941424 7.80828 0.941848C7.9285 0.943127 8.04352 0.991133 8.12898 1.07571L11.0208 3.94581C11.0633 3.98739 11.0969 4.03703 11.1199 4.09182C11.1429 4.1466 11.1547 4.20542 11.1547 4.26483Z' fill='%23003DA5' stroke='%23003DA5' stroke-width='0.5'/%3E%3C/svg%3E\") !important;\n    color: #ffffff;\n    /* background: #6366F1; */\n    border: 0px;\n    padding: 0.85rem 1.25rem;\n    background-color: transparent !important;\n    background-repeat: no-repeat !important;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .p-fileupload-choose-selected {\n    .p-button-label {\n      color: red;\n    }\n  }\n\n  .p-button[aria-label=\"Upload\"],\n  .p-button[aria-label=\"Cancel\"],\n  .p-button-icon {\n    display: none;\n  }\n\n  .p-fileupload-buttonbar {\n    background: transparent;\n    border: 0;\n    padding: 0 20px;\n  }\n\n  .p-fileupload-content {\n    background: #ffffff;\n    padding: 10px;\n    border: 0;\n    color: #495057;\n    border-bottom-right-radius: 6px;\n    border-bottom-left-radius: 6px;\n    position: absolute;\n    top: 69%;\n    left: 0;\n\n    .p-progressbar {\n      display: none;\n    }\n  }\n\n  .p-fileupload-row {\n    display: flex;\n    align-items: center;\n    padding: 0;\n    margin: 0;\n    height: 30px;\n\n    div {\n      font-size: 10px;\n    }\n\n    .p-badge,\n    .p-button {\n      display: none;\n    }\n  }\n}\n\n.p-checkbox.p-checkbox-disabled,\n.disabled-text {\n  color: #acacac;\n}\n\n.enabled-text {\n  color: #595959;\n}\n\n.disabled-add {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.delete-icons {\n  cursor: pointer;\n}\n\nsup {\n  color: red;\n}\n\n.footer-buttons {\n  padding: 5;\n  background: \"#FAFAFA\";\n}\n\n.align-item-center {\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  height: 100%;\n}\n\n.upload-cic-pmp-wrapper {\n  margin-left: 25px;\n  color: #003da5;\n  padding-top: 16px;\n}\n\n.rejection-reason-header {\n  margin-left: 20px;\n  padding: 5px;\n}\n\n.rejection-table {\n  padding: 10px 10px 10px 20px;\n\n  .p-datatable-selectable .p-selectable-row {\n    cursor: default !important;\n  }\n\n  .p-datatable .p-column-header-content {\n    justify-content: left;\n  }\n}\n\n\n.approval-status-text {\n  margin-left: 10px;\n  font-size: 14px;\n  font-weight: bold;\n\n  &.Approved {\n    color: #03a000;\n  }\n\n  &.Rejected {\n    color: #ff0000;\n  }\n}\n\n._loading_overlay_wrapper {\n  &>.content-layout {\n    // padding-top: 24px;\n    padding-top: 8px;\n    // padding-bottom: 32px;\n    position: relative;\n    overflow: hidden;\n    height: 100%;\n\n    .pi-times {\n      position: absolute;\n      width: 14px;\n      height: 14px;\n      right: 41px;\n      top: 23px;\n      cursor: pointer;\n    }\n\n    .icon-items {\n      .filter-icon {\n        cursor: pointer;\n        color: #003da5;\n        width: 14px;\n        height: 19px;\n        margin-top: 8px;\n      }\n\n      .add-new-design-intent-icon {\n        cursor: pointer;\n        color: #003da5;\n        width: 18px;\n        height: 18px;\n        margin-top: 9px;\n      }\n\n      .icon-label {\n        font-size: 10px;\n        color: #003da5;\n        line-height: 13px;\n        padding-top: 8px;\n      }\n\n      .p-checkbox+.icon-label {\n        padding-top: 3px;\n      }\n\n      &.disabled {\n        pointer-events: none;\n        opacity: 0.4;\n      }\n    }\n\n    &.task-layout {\n      height: auto;\n    }\n  }\n\n  &.tab-wrapper {\n    border: 0 !important;\n    border-radius: 0;\n\n    &>.content-layout {\n      background: rgba(1, 104, 191, 0.07);\n      padding-top: 0;\n\n      .tabular-view {\n        position: relative;\n        padding-bottom: 38px;\n\n        .form-buttons {\n          position: absolute;\n          background: white;\n          text-align: right;\n          width: 100%;\n          left: 0;\n          bottom: 0;\n        }\n      }\n    }\n  }\n}\n\n//added for artwork status cic rejected\n.artworkStatus .cic-img .pi-times {\n  right: 0px !important;\n  top: 0px !important;\n  position: relative !important;\n}\n\n.ps-error-msg {\n  margin-left: 30px;\n}\n\n.footerbutton-display {\n  display: flex !important;\n  justify-content: space-between !important;\n}\n\n.footerbutton-flex {\n  display: flex;\n  gap: 24px;\n}\n.vpn-warning{\n  font-size: 14px;\n   color: #ff0000;\n   padding-left: 15px;\n}\n\n.mass-update-intent-icon {\n  cursor: pointer;\n  color: #003da5;\n  font-size: 1.5rem;\n  margin-top: 9px;\n}\n\n.email_share_button {\n  padding: 4px 8px !important;\n} \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
